import React from 'react';
import { Alert, Button, Badge } from 'reactstrap';

const MaintenanceModeSection = ({ maintenanceStatus, onEnable, onDisable, isLoading, maintenanceModeMessage, maintenanceModeTypeMessage }) => {
    return (
        <div className="action-item mb-4 p-3 border rounded">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">Режим технических работ</h6>
                <Badge className={maintenanceStatus ? "active" : "unactive"}>
                    {maintenanceStatus ? "ВКЛЮЧЕН" : "ВЫКЛЮЧЕН"}
                </Badge>
            </div>
            <div className="d-flex gap-2">
                <Button
                    className="dt1520-button active-dt1520-button view-button green-button footer-button mr-2"
                    onClick={onEnable}
                    disabled={isLoading || !!maintenanceStatus}
                    outline
                >
                    {isLoading ? 'Включение...' : 'Включить техработы'}
                </Button>
                <Button
                    className="dt1520-button active-dt1520-button view-button red-button footer-button mr-2"
                    onClick={onDisable}
                    disabled={isLoading || !maintenanceStatus}
                    outline
                >
                    {isLoading ? 'Выключение...' : 'Выключить техработы'}
                </Button>
            </div>
            <small className="text-muted d-block mt-2">
                В режиме технических работ пользователи увидят сообщение о временной недоступности работы утилит при попытке обращения
            </small>

            {maintenanceModeMessage && (
                <Alert color={maintenanceModeTypeMessage === 'success' ? 'success' : 'danger'} className="mt-3 ml-3">
                    {maintenanceModeMessage}
                </Alert>
            )}
        </div>
    );
};

export default MaintenanceModeSection;